import { motion } from "framer-motion";
import { RevealText } from "./RevealText";
import { IMAGES } from "../../lib/landing";

const CHAPTERS = [
  {
    n: "01",
    title: "Consapevolezza",
    body:
      "Informare è il primo atto di protezione. Diffondiamo contenuti chiari sulla violenza di genere per riconoscere i segnali e rompere il silenzio.",
  },
  {
    n: "02",
    title: "Prevenzione",
    body:
      "Strumenti concreti prima che accada: percorsi sicuri, condivisione della posizione in tempo reale e una rete di persone fidate sempre a portata di mano.",
  },
  {
    n: "03",
    title: "Protezione",
    body:
      "Quando ogni secondo conta, un solo gesto attiva l'allarme SOS e allerta i tuoi contatti con la tua posizione esatta. Immediato, silenzioso, affidabile.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-28 sm:py-40 bg-brand-bg"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 gap-x-6">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <span className="text-xs uppercase tracking-[0.25em] text-brand-primary">
                Il nostro manifesto
              </span>
              <h2 className="mt-6 font-display font-medium tracking-tight leading-[0.95] text-brand-text text-4xl sm:text-5xl md:text-6xl">
                <RevealText
                  inView
                  lines={["La sicurezza", "non è un", "privilegio."]}
                  lineClassName=""
                />
              </h2>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="mt-10 relative aspect-[4/5] w-full max-w-sm overflow-hidden rounded-[2px]"
              >
                <img
                  src={IMAGES.community}
                  alt="Donne insieme"
                  className="h-full w-full object-cover"
                />
              </motion.div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 flex flex-col">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-15%" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className={`py-10 border-t border-brand-line ${
                  i === CHAPTERS.length - 1 ? "border-b" : ""
                } ${i % 2 === 1 ? "lg:pl-16" : ""}`}
                data-testid={`manifesto-chapter-${c.n}`}
              >
                <div className="flex items-baseline gap-5">
                  <span className="font-serif-accent italic text-brand-primary text-2xl">
                    {c.n}
                  </span>
                  <h3 className="font-display text-3xl sm:text-4xl text-brand-text tracking-tight">
                    {c.title}
                  </h3>
                </div>
                <p className="mt-5 text-brand-muted text-base md:text-lg leading-relaxed max-w-lg">
                  {c.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
